import React, { useState, useEffect } from 'react';

const OfficialInfoTable = () => {
  const [officials, setOfficials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOfficials = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem('token');
        
        if (!token) {
          throw new Error('Authentication token not found in local storage');
        }
        
        const response = await fetch('https://admindashboard.clns.in/api/off_client/dashboard_official_list/', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error(`API request failed with status: ${response.status}`);
        }
        
        const data = await response.json();
        setOfficials(data.officials || []);
        setLoading(false);
      } catch (err) {
        console.error('Failed to fetch officials:', err);
        setError(err.message);
        setLoading(false);
      }
    };
    
    fetchOfficials();
  }, []);

  if (loading) {
    return <div className="flex justify-center items-center p-8">Loading officials data...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3 border-b text-left">ID</th>
            <th className="p-3 border-b text-left">Name</th>
            <th className="p-3 border-b text-left">Email</th>
            <th className="p-3 border-b text-left">Mobile</th>
            <th className="p-3 border-b text-left">City</th>
            <th className="p-3 border-b text-left">Status</th>
            <th className="p-3 border-b text-left">Court</th>
            <th className="p-3 border-b text-left">Experience</th>
            <th className="p-3 border-b text-left">Last Login</th>
          </tr>
        </thead>
        <tbody>
          {officials.length > 0 ? (
            officials.map((official) => (
              <tr key={official.id} className="hover:bg-gray-50">
                <td className="p-3 border-b">{official.id}</td>
                <td className="p-3 border-b">{official.name}</td>
                <td className="p-3 border-b">{official.contact_details?.email || '-'}</td>
                <td className="p-3 border-b">{official.contact_details?.mobile_num || '-'}</td>
                <td className="p-3 border-b">{official.contact_details?.city || '-'}</td>
                <td className="p-3 border-b">
                  <span 
                    className={`px-2 py-1 rounded-full text-xs ${
                      official.status?.active_status 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}
                  >
                    {official.status?.active_status ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td className="p-3 border-b">{official.official?.court || '-'}</td>
                <td className="p-3 border-b">{official.profile?.years_experience || '-'}</td>
                <td className="p-3 border-b">
                  {official.contact_details?.last_login_time 
                    ? new Date(official.contact_details.last_login_time).toLocaleString() 
                    : 'Never'}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="p-4 text-center text-gray-500">
                No officials found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default OfficialInfoTable;